import React from 'react'

export default function Error(_props) {
  return (
    <div className="jumbotron">
      <h1>该页面不存在</h1>
      <p>很抱歉，不知道您是怎么到这里的。</p>
      <p>如有疑问，可以通过 <a href="mailto:sayue2019@qq.com">sayue2019@qq.com</a> 联系我们</p>
    </div>
  )
}



// WEBPACK FOOTER //
// ./modules/NotFound.js